/**
 * Canonical timeline → twreact Stepper props (pure). A step is done when it has
 * a timestamp; the current step is the first one without. When every step is
 * done, currentStep is past the end so all render as completed. `activeKey` (the
 * entity's status) pins the current step when that status is still in progress.
 */
export function timelineSteps(timeline, fmt = (x) => x, activeKey) {
  const list = timeline || [];
  let current = list.findIndex((s) => !s.at);
  if (current === -1) current = list.length;
  // A status that is a waiting state (e.g. awaiting approval) is the current step, not done.
  const active = activeKey ? list.findIndex((s) => s.key === activeKey) : -1;
  if (active !== -1 && active < list.length - 1) current = active;
  const steps = list.map((s, i) => ({
    title: s.title,
    description: s.at ? fmt(s.at) : i === current ? 'In progress' : 'Pending',
  }));
  return { steps, currentStep: current };
}
